module.exports = __webpack_public_path__ + "static/media/26UNRWA26.da396563.jpg";